// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bipUtg94NyECqY_djjFb {
  width: 100%;
  background-color: var(--white);
}

.dq7jNmhxWRd5OY4KVdNQ {
  --vertical-padding: 1.25rem;

  padding: var(--vertical-padding) 0;
  max-width: 90rem;
  margin: 0 auto;
  display: flex;
}

.vQkjuaDuF7aNyzK3zqJI {
  --vertical-padding: 1.25rem;

  display: flex;
  justify-content: space-between;
  align-items: center
}

.vQkjuaDuF7aNyzK3zqJI .dq7jNmhxWRd5OY4KVdNQ {
    margin: 0;
  }

.Fo0WH5SxrvRErgQtk7Dl {
  font-size: 1rem;
  white-space: nowrap;
}

.GLZZhwvgtYVJ1mEOhSa3 {
  margin-right: 0.625rem;
  margin-left: 0.625rem;
  min-width: 1.375rem;
  min-height: 1.375rem;
  color: var(--midnight-purple);
}

@media only screen and
  (min-width: 1280px) {
  .dq7jNmhxWRd5OY4KVdNQ {
    flex-wrap: wrap;
  }
}

@media only screen and
  (min-width: 1024px) and
  (max-width: 1279px) {
  .dq7jNmhxWRd5OY4KVdNQ {
    flex-wrap: wrap;
  }
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .dq7jNmhxWRd5OY4KVdNQ {
    overflow-x: auto;
  }
}

@media only screen and
  (max-width: 639px) {
  .dq7jNmhxWRd5OY4KVdNQ {
    overflow-x: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Breadcrumbs/Breadcrumbs.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,2BAAwB;;EAExB,kCAAkC;EAClC,gBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,2BAAwB;;EAExB,aAAa;EACb,8BAA8B;EAC9B;AAKF;;AAHE;IACE,SAAS;EACX;;AAGF;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,sBAAkB;EAClB,qBAAiB;EACjB,mBAAe;EACf,oBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;;EACE;IACE,eAAe;EACjB;AACF;;AAEA;;;EACE;IACE,eAAe;EACjB;AACF;;AAEA;;;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".breadcrumbs {\n  width: 100%;\n  background-color: var(--white);\n}\n\n.breadcrumbsInnerWrapper {\n  --vertical-padding: 20px;\n\n  padding: var(--vertical-padding) 0;\n  max-width: 1440px;\n  margin: 0 auto;\n  display: flex;\n}\n\n.withBusinessForm {\n  --vertical-padding: 20px;\n\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  & .breadcrumbsInnerWrapper {\n    margin: 0;\n  }\n}\n\n.link {\n  font-size: 16px;\n  white-space: nowrap;\n}\n\n.chevron {\n  margin-right: 10px;\n  margin-left: 10px;\n  min-width: 22px;\n  min-height: 22px;\n  color: var(--midnight-purple);\n}\n\n@media (--desktop-large) {\n  .breadcrumbsInnerWrapper {\n    flex-wrap: wrap;\n  }\n}\n\n@media (--desktop-small) {\n  .breadcrumbsInnerWrapper {\n    flex-wrap: wrap;\n  }\n}\n\n@media (--tablet) {\n  .breadcrumbsInnerWrapper {\n    overflow-x: auto;\n  }\n}\n\n@media (--mobile) {\n  .breadcrumbsInnerWrapper {\n    overflow-x: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breadcrumbs": `bipUtg94NyECqY_djjFb`,
	"breadcrumbsInnerWrapper": `dq7jNmhxWRd5OY4KVdNQ`,
	"withBusinessForm": `vQkjuaDuF7aNyzK3zqJI`,
	"link": `Fo0WH5SxrvRErgQtk7Dl`,
	"chevron": `GLZZhwvgtYVJ1mEOhSa3`
};
export default ___CSS_LOADER_EXPORT___;
